export const tooltips: { [key: number]: string } = {
  1: "AA2025 Memories",
  2: "Tinnitus",
  3: "Smell the flowers",
  4: "Fuck Sour Puss",
  5: "White is not right",
  6: "Too much Radio not enough Head",
  7: "IQ 160",
  8: "Happy 60th Birthday",
  9: "Meow!",
  10: "Gambler Supreme",
  11: "Karma Chameleon",
  12: "Balls and Flowers",
  13: "I would fuck it",
  14: "This shit cool ngl",
  15: "55-59",
  16: "Rodentia",
  17: "King of the Pirates!",
  18: "Blacked Out",
  19: "Lead Emulation",
  20: "My brightest pupil",
  21: "Trees and NPC Slavery",
  22: "You're friends are gonna be jealous",
  23: "Drip or drown",
  24: "Senbonzakura Kageyoshi",
  25: "55-59 again?!",
  26: "Anita Simulator",
  27: "A sky full of stars",
  28: "How it started",
  29: "DELAYED SORRY",
  30: "Brown queen",
  31: "Bare minimum",
  32: "Its aight",
  33: "Ehhh average",
  34: "Okay this is epic",
  35: "STOP HER!",
  36: "Wife material",
};